import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getConsent, setConsent } from "../../../utils/cookieConsent";
import { grantConsent as analyticsGrant, denyConsent as analyticsDeny } from "../../../lib/analytics";
import "./CookieBanner.less";

export function CookieBanner() {
  const { t } = useTranslation("common");
  const [visible, setVisible] = useState(() => getConsent() === null);

  if (!visible) return null;

  function handleDecision(decision: "accept" | "decline") {
    setConsent(decision);
    if (decision === "accept") analyticsGrant();
    else analyticsDeny();
    setVisible(false);
  }

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie consent">
      <div className="cookie-banner__body">
        <p className="cookie-banner__text">
          <Trans
            i18nKey="cookieBanner.text"
            ns="common"
            components={{ bold: <strong /> }}
          />{" "}
          <a href="/legal/cookies" className="cookie-banner__link">
            {t("cookieBanner.cookiePolicy")}
          </a>
        </p>
        <div className="cookie-banner__actions">
          <button
            className="cookie-banner__btn cookie-banner__btn--accept"
            onClick={() => handleDecision("accept")}
          >
            {t("cookieBanner.accept")}
          </button>
          <button
            className="cookie-banner__btn cookie-banner__btn--decline"
            onClick={() => handleDecision("decline")}
          >
            {t("cookieBanner.decline")}
          </button>
        </div>
      </div>
    </div>
  );
}
